/**
 * The app's own origin — `https://app.nexoya.io`, `http://localhost:3000`, …
 *
 * A FUNCTION, not a constant, and that is the whole point. As a constant this
 * read `window.location` at MODULE SCOPE, so importing anything that transitively
 * reached it — `Auth/Auth` -> `graphql/provider/queryProviders` ->
 * `context/ProvidersProvider` -> `components/AvatarProvider` — threw
 * `ReferenceError: window is not defined` in every node-env Vitest suite, before
 * a single test ran. Deferring the read to call time costs nothing (both call
 * sites are inside the browser-only auth client) and keeps the module importable
 * anywhere.
 */
export const baseWindowUrl = (): string => `${window.location.protocol}//${window.location.host}`;
